module.exports = __webpack_public_path__ + "static/bootstrap-03747b4f895582fb0c9d137c20074b3e.png";